<script lang="ts">
  export let title = ""
  export let subtitle = ""
  export let clean = false;
</script>

<div class="course-module-card {clean ? 'clean' : ''}">
  <div class="course-module-wrapper">
    <h6 class="course-module-subtitle">{subtitle}</h6>
    <h4 class="course-module-title">{@html title}</h4>
  </div>
</div>

<style type="text/scss" lang="scss" scoped>
  .course-module-card {
    @apply rounded bg-white shadow-md;
  }

  .course-module-card.clean {
    box-shadow: none;
    background: none;
    border: none;
  }
  .course-module-wrapper {
    @apply p-4 pb-6 md:p-6 md:pb-8;
  }

  .course-module-subtitle {
    @apply font-sans font-semibold;
    @apply text-sm md:text-base uppercase tracking-wider;
    @apply mb-3;
  }

  .course-module-title {
    @apply font-serif font-medium;
    @apply text-md md:text-lg;
  }
</style>
